import * as BasketAction from "./BasketAction";

export default function basketReducer(state = {}, action) {
    switch (action.type) {
        case BasketAction.REQUEST_BASKET_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    ...action.payload
                };
            }
        case BasketAction.ADD_ITEM_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    ...action.payload
                };
            }
        case BasketAction.ADD_ITEM_LOCALSTORAGE_FINISHED:
            return {
                ...state,
                ...action.payload
            };
        case BasketAction.ADD_ADDITIONAL_INFO_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    backendAcceptedCardPayment: action.payload.accepted
                };
            }
        case BasketAction.DELETE_BACKEND_ACCEPTANCE_PAYMENT_FROM_STATE:
            return {
                ...state,
                backendAcceptedCardPayment: null
            }

        default:
            return state;
    }
}
